import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=b2437d9c&scoped=true&"
import script from "./navigation.vue?vue&type=script&lang=js&"
export * from "./navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2437d9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2437d9c')) {
      api.createRecord('b2437d9c', component.options)
    } else {
      api.reload('b2437d9c', component.options)
    }
    module.hot.accept("./navigation.vue?vue&type=template&id=b2437d9c&scoped=true&", function () {
      api.rerender('b2437d9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/navigation.vue"
export default component.exports